import type { FirebaseRepository } from './FirebaseRepository'
import type { MobxDocument } from '../types'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import {
  type FirestorePeerReviewQuestion,
  empty,
} from '../firestore/SectionAssignmentPeerReviewQuestion/schema'

export class SectionAssignmentPeerReviewQuestion extends ObservableModelWithDecorators<FirestorePeerReviewQuestion> {
  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestorePeerReviewQuestion>
  ) {
    super(repository, doc)
  }

  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }
}
